import {
  renderTime,
} from '../../userUtils';

const getCommon = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    id: productEventId,
    content,
  } = event;

  const {
    ackRequired,
    productId,
  } = content;

  const status = '';
  const version = 0;
  const warningNumber = '';
  const severityName = '';
  const severityId = -1;
  const issueTime = '';

  return {
    productEventId,
    productId,
    status,
    version,
    ackRequired,
    severityName,
    severityId,
    warningNumber,
    issueTime,
  };
};

const getListFeature = (
  productType = { singularName: '' },
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;

  const heading = `${productName}`;
  const subtitle = '';
  return {
    heading,
    subtitle,
  };
};

const getMapFeature = (
  productType = { singularName: '' },
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;
  const heading = productName;
  const subtitle = '';
  const endTime = '';
  const startTime = '';
  // NOTE: might not want this
  const bbox = [0, 0];
  const isPointInTime = false;

  return {
    heading,
    subtitle,
    endTime,
    startTime,
    bbox,
    isPointInTime,
  };
};

const getState = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    state,
  } = event;

  const {
    read,
    acked,
  } = state;

  return {
    read,
    acked,
    playingSound,
  };
};

const getFeatures = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  map: getMapFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  list: getListFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});


export default (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  common: getCommon(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  state: getState(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  features: getFeatures(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});
